import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormItemGroup', null, { withChildren: true });
